//
//  ******* In-memory updated Related *******
//

export const COMPANY_PROFILE_INIT = 'COMPANY_PROFILE_INIT';

//
//  ******* Fetch Related *******
//

export const COMPANY_PROFILE_FETCH_BEGIN = 'COMPANY_PROFILE_FETCH_BEGIN';
export const COMPANY_PROFILE_FETCH_SUCCESS = 'COMPANY_PROFILE_FETCH_SUCCESS';
export const COMPANY_PROFILE_FETCH_FAIL = 'COMPANY_PROFILE_FETCH_FAIL';

//
//  ******* Patch Related *******
//

export const COMPANY_PROFILE_PATCH_BEGIN = 'COMPANY_PROFILE_PATCH_BEGIN';
export const COMPANY_PROFILE_PATCH_SUCCESS = 'COMPANY_PROFILE_PATCH_SUCCESS';
export const COMPANY_PROFILE_PATCH_FAIL = 'COMPANY_PROFILE_PATCH_FAIL';

//
//  ******* Submit Related *******
//
export const COMPANY_PROFILE_SUBMIT_BEGIN = 'COMPANY_PROFILE_SUBMIT_BEGIN';
export const COMPANY_PROFILE_SUBMIT_SUCCESS = 'COMPANY_PROFILE_SUBMIT_SUCCESS';
export const COMPANY_PROFILE_UPLOAD_BEGIN = 'COMPANY_PROFILE_UPLOAD_BEGIN';
export const COMPANY_PROFILE_SUBMIT_FAIL = 'COMPANY_PROFILE_SUBMIT_FAIL';

//
//  ******* Company Document Upload Setup ******
//

export const COMPANY_PROFILE_DOCUMENT_UPLOAD_BEGIN = 'COMPANY_PROFILE_DOCUMENT_UPLOAD_BEGIN';
export const COMPANY_PROFILE_DOCUMENT_UPLOAD_SUCCESS = 'COMPANY_PROFILE_DOCUMENT_UPLOAD_SUCCESS';
export const COMPANY_PROFILE_DOCUMENT_UPLOAD_FAIL = 'COMPANY_PROFILE_DOCUMENT_UPLOAD_FAIL';

//
//  ******* Delete Related *******
//

export const DELETE_AUDIT_CERT = 'DELETE_AUDIT_CERT';

//
//  ******* Update Related *******
//

// export const COMPANY_PROFILE_UPDATE_BEGIN = 'COMPANY_PROFILE_UPDATE_BEGIN';
// export const COMPANY_PROFILE_UPDATE_SUCCESS = 'COMPANY_PROFILE_UPDATE_SUCCESS';

export const COMPANY_PROFILE_RESET_STATUS = 'COMPANY_PROFILE_RESET_STATUS';

//
//  ******* Supplier Document Upload Setup ******
//
export const SUPPLIER_DOCUMENT_UPLOAD_BEGIN = 'SUPPLIER_DOCUMENT_UPLOAD_BEGIN';
export const SUPPLIER_DOCUMENT_UPLOAD_SUCCESS = 'SUPPLIER_DOCUMENT_UPLOAD_SUCCESS';
export const SUPPLIER_DOCUMENT_UPLOAD_FAIL = 'SUPPLIER_DOCUMENT_UPLOAD_FAIL';
